import type { UISize } from "./UIContext";

/**
 * Pixel sizes aligned with Semantic UI icon scale (1em / 1.5em large),
 * not text SIZE_FONT — Lucide strokes look thin if undersized.
 */
export const ICON_SIZE_PX: Record<UISize, number> = {
  small: 14,
  medium: 16,
  large: 24,
};
